import { ButtonGroup } from "@blueprintjs/core"
import { isNumber, isString } from "lodash-es"
import React from "react"
import CustomButton from "../Atoms/CustomButton"

interface TablePaginationProps {
  /**
   * Default className and style properties of react
   */
  className?: string
  style?: React.CSSProperties | undefined
  minimal?: boolean
  /**
   * Specifies the current page the user is on
   * 0,1,2 etc.
   */
  page: number | string
  /**
   * a generalized callback called when the current page is changed
   */
  onPageChange: (page: number) => void
  /**
   * a boolean which disabled the 'next' button of the component
   * (usally set to true when there are no items in the list)
   */
  disabledNext?: boolean
  disabled?: boolean
}
const TablePagination = ({
  className,
  style,
  minimal,
  page,
  onPageChange,
  disabledNext,
  disabled,
}: TablePaginationProps) => {
  // Converts the page string to an integer
  function parsePage(page: string | number) {
    if (isString(page)) return page ? parseInt(page) : 0
    return page ?? 0
  }
  function handlePagePrevious() {
    const pageInt = parsePage(page)
    if (isNumber(pageInt)) if (pageInt > 0) onPageChange(pageInt - 1)
  }

  function handlePageNext() {
    const pageInt = parsePage(page)
    if (isNumber(pageInt)) onPageChange(pageInt + 1)
  }

  const pageInt = parsePage(page)

  return (
    <div className={className} style={style}>
      <span className="text-sm font-600">Page {pageInt + 1}</span>
      <ButtonGroup className="ml-2">
        <CustomButton
          intent="none"
          minimal={minimal}
          icon="arrow-left"
          onClick={handlePagePrevious}
          disabled={disabled}
        />
        <CustomButton
          id="vt_pagination_next_button"
          disabled={disabled ?? disabledNext}
          className="ml-2"
          intent="none"
          minimal={minimal}
          icon="arrow-right"
          onClick={handlePageNext}
        />
      </ButtonGroup>
    </div>
  )
}

export default TablePagination
